import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchTaskBoard() {
  return apiFetch("/api/v1/tasks/board");
}

export function fetchTaskProjects() {
  return apiFetch("/api/v1/tasks/projects");
}

export function createTaskProject(name) {
  return apiFetch("/api/v1/tasks/projects", {
    method: "POST",
    body: stringifySnake({ name }),
  });
}

export function createLane(name) {
  return apiFetch("/api/v1/tasks/lanes", {
    method: "POST",
    body: stringifySnake({ name }),
  });
}

export function updateLane(laneId, payload) {
  return apiFetch(`/api/v1/tasks/lanes/${laneId}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteLane(laneId) {
  return apiFetch(`/api/v1/tasks/lanes/${laneId}`, { method: "DELETE" });
}

export function reorderLanes(laneIds) {
  return apiFetch("/api/v1/tasks/lanes/reorder", {
    method: "POST",
    body: stringifySnake({ laneIds }),
  });
}

export function createTask(payload) {
  const body = normalizePayload(payload);
  return apiFetch("/api/v1/tasks", {
    method: "POST",
    body: stringifySnake(body),
  });
}

export function updateTask(taskId, payload) {
  const body = normalizePayload(payload);
  return apiFetch(`/api/v1/tasks/${taskId}`, {
    method: "PATCH",
    body: stringifySnake(body),
  });
}

export function deleteTask(taskId) {
  return apiFetch(`/api/v1/tasks/${taskId}`, { method: "DELETE" });
}

export function reorderTasks(updates) {
  const normalized = updates.map((update) => normalizePayload(update));
  return apiFetch("/api/v1/tasks/reorder", {
    method: "POST",
    body: stringifySnake({ updates: normalized }),
  });
}

function normalizePayload(payload) {
  if (!payload) return payload;
  const { laneId, taskId, projectId, ...rest } = payload;
  return {
    ...rest,
    lane_id: laneId ?? rest.lane_id,
    task_id: taskId ?? rest.task_id,
    project_id: projectId ?? rest.project_id,
  };
}
